import { createApp } from 'vue'
import ElementPlus from 'element-plus'

import './styles/global.css'
// import 'element-plus/lib/theme-chalk/display.css'
import 'element-plus/dist/index.css'
//import 'element-plus/lib/style.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
// 如果您正在使用CDN引入，请删除下面一行。
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import store from './store'
import util from './utils/util.js'
import kaung from '@/utils/kaung.js'
import request from '@/utils/request.js'

//import print from 'print-js'

import signalr from './utils/signalr'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(ElementPlus, { locale: zhCn, zIndex: 3000 })
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(signalr)

// 将 Vuex store 注入到 kaung 工具，供 initCompanys 等方法访问 ShowOrgFilters 配置
kaung._store = store

// 全局 mixin：为所有组件注入 showOrgFilters，基于 WebSetting 配置控制公司和库房选择器的显隐
app.mixin({
    computed: {
        showOrgFilters() {
            return this.$store.getters.getWebSetting?.showOrgFilters !== false
        }
    }
})


import Importer from "./components/importer.vue";
app.component("importer", Importer);



app.mount('#app')
//工具类封装成插件
app.config.globalProperties.$util = util
app.config.globalProperties.$kaung = kaung
app.config.globalProperties.$http = request

// 注册 Service Worker（开发和生产环境都启用，用于测试PWA功能）
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered:', registration);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}

// import wx from "weixin-js-sdk";
// app.config.globalProperties.$wxsdk = wx


